<template>
  <v-container>
    <ValidationObserver ref="objects" v-slot="{ invalid }">
      <v-form>
        <v-row>
          <v-col cols="12">
            <ValidationProvider name="States" rules="required">
              <v-select
                v-model="selectedStates"
                :items="states"
                item-value="id"
                item-text="title"
                :menu-props="{ maxHeight: '200' }"
                label="Select state(s)"
                clearable
                hint="Pick states"
                persistent-hint
                :error-messages="errors"
                slot-scope="{ errors }"
              ></v-select>
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Type" rules="required">
              <v-select
                v-model="defaultFileType"
                :items="allowedFileTypes"
                :menu-props="{ maxHeight: '400' }"
                label="Type"
                auto-select-first
                flat
              ></v-select>
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="justify-end">
            <v-btn class="primary" @click="okAction()" :disabled="invalid">Export</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </ValidationObserver>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import store from '@/store/index';
import ReportService from '@/services/ReportService';
import { getError } from '@/utils/helpers';

extend('required', required);

export default {
  name: 'ByStateExportDialog',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    /**
     * The prefix to use for the report file name
     */
    reportFilenamePrefix: {
      type: String,
      default: 'State'
    },
    /**
     * Name used for report in Laravel REST API
     */
    reportName: {
      type: String,
      default: 'state'
    },
    /**
     * Report client show or hide
     */
    reportClient: {
      type: Boolean,
      default: false
    },
    /**
     * File types allowed for export
     */
    allowedFileTypes: {
      type: Array,
      default: () => ['pdf']
    },
    /**
     * The default file type to select for the export
     */
    defaultFileType: {
      type: String,
      default: 'pdf'
    }
  },
  methods: {
    load() {
      store.dispatch('state/getStatesByCountry', 'au');
    },
    /**
     * Create the file name for the export
     */
    filename() {
      let filename = this.reportFilenamePrefix + ' ' + this.selectedStates;
      return filename.replace(/[^a-z0-9]/gi, '-') + '.' + this.defaultFileType;
    },
    /**
     * Save method for the form
     */
    async okAction() {
      if (this.defaultFileType === 'html') {
        const url = `${process.env.VUE_APP_API_URL}/export/${this.reportName}?state_id=${this.selectedStates}&file_type=${this.defaultFileType}`;
        window.open(url, '_blank').focus();
        return;
      } else {
        ReportService.getReport({
          report: this.reportName,
          filename: this.filename(),
          state: this.selectedStates
        }).catch(error => {
          store.dispatch('ui/snackbarError', getError(error));
        });
      }
    }
  },
  computed: {
    ...mapGetters('state', ['loading', 'error', 'states'])
  },
  mounted() {
    this.load();
  },
  data: () => ({
    selectedStates: []
  })
};
</script>
